// @flow

import type {Reducer} from '@travel-frontend/state-handling-sdk';
import type {ReservationState} from 'redux/v1/reservation/ReservationState';

import {combineReducers} from 'redux';

import {offerReducer} from 'redux/v1/reservation/offer/reducer';
import {selectReducer} from 'redux/v1/reservation/select/reducer';
import {unselectReducer} from 'redux/v1/reservation/unselect/reducer';

export const reservationReducer: Reducer<ReservationState> = combineReducers({
  offer: offerReducer,
  select: selectReducer,
  unselect: unselectReducer,
});
